module.exports = __webpack_public_path__ + "static/img/wdtx1-3.3a1c316.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdtx1-3.png
// module id = 898
// module chunks = 0